import React from 'react';
import {Routes, Route, Navigate} from 'react-router-dom';
import { ConfigProvider } from 'antd';
import dayjs from "dayjs";
import "dayjs/locale/ru";
import updateLocale from "dayjs/plugin/updateLocale";
import locale from 'antd/locale/ru_RU';
import './App.css';
import MainLayout from "./layouts/MainLayout";
import HomePage from "./pages/HomePage";
import CatalogPage from "./pages/CatalogPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import AuthLayout from "./layouts/AuthLayout";
import LogoutPage from "./pages/LogoutPage";
import ProfilePage from "./pages/ProfilePage";
import CatalogCourseFormPage from "./pages/catalog/CatalogCourseFormPage";
import CatalogListPage from "./pages/catalog/CatalogListPage";
import UsersPage from "./pages/UsersPage";
import CourseDetailPage from "./pages/catalog/CourseDetailPage";
import OrdersPage from "./pages/OrdersPage";
import TestingPage from "./pages/TestingPage";
import AccessesPage from "./pages/AccessesPage";
import PublicOrder from "./pages/PublicOrder";
import axios from "axios";
import useAuth from "./hooks/useAuth";
import StatisticPage from "./pages/StatisticPage";
import OptionsPage from "./pages/setting/OptionsPage";
import CartPage from "./pages/CartPage";
import DirectPage from "./pages/DirectPage";
import LinkOrder from "./pages/LinkOrder";
import OrganizationsPage from "./pages/OrganizationsPage";
import ApplicationsManagementPage from "./pages/ApplicationsManagementPage";

function Redirect()
{

}

dayjs.extend(updateLocale);
dayjs.updateLocale("ru", {
    weekStart: 1,
});
function App() {

    const {roles, isAdminOrManagerOrPartner, isCurator} = useAuth();

  return (
      <ConfigProvider
          locale={locale}
          theme={{
              token: {
                  colorPrimary: '#4f46e5',
              },
          }}
      >
      <Routes>
          <Route path="/" element={<Navigate to="/cabinet/catalog"/>}></Route>
          <Route path="/cabinet"  element={<MainLayout/>}>
              <Route path="" element={<Navigate to="/cabinet/catalog"/>}></Route>
              <Route path="catalog" element={<CatalogPage/>}>
                  <Route path="" element={<CatalogListPage/>}></Route>
                  <Route path="category/:id" element={<CatalogListPage/>}></Route>
                  <Route path="form/course/:id" element={roles.includes('ROLE_ADMIN') && <CatalogCourseFormPage/>}></Route>
                  <Route path="course/:id" element={<CourseDetailPage/>}></Route>
              </Route>
              <Route path="users" element={(roles.includes('ROLE_ADMIN') || roles.includes('ROLE_MANAGER') || roles.includes('ROLE_PARTNER')) && <UsersPage/>}></Route>
              <Route path="users/:id" element={(roles.includes('ROLE_ADMIN') || roles.includes('ROLE_MANAGER') || roles.includes('ROLE_PARTNER')) && <ProfilePage/>}></Route>
              <Route path="profile" element={<ProfilePage key={'profile'}/>}></Route>
              <Route path="orders" element={<OrdersPage/>}></Route>
              <Route path="testing" element={<TestingPage/>}></Route>
              <Route path="accesses" element={(roles.includes('ROLE_ADMIN') || roles.includes('ROLE_MANAGER') || roles.includes('ROLE_PARTNER')) && <AccessesPage/>}></Route>
              <Route path="statistic" element={(isAdminOrManagerOrPartner || isCurator) && <StatisticPage/>}></Route>
              <Route path="setting">
                  <Route path="options" element={roles.includes('ROLE_ADMIN') && <OptionsPage/>}></Route>
              </Route>
              <Route path="cart" element={<CartPage/>}></Route>
              <Route path="link-orders" element={(roles.includes('ROLE_ADMIN') || roles.includes('ROLE_MANAGER')) && <LinkOrder/>}></Route>
              <Route path="organizations" element={(roles.includes('ROLE_ADMIN') || roles.includes('ROLE_MANAGER') || roles.includes('ROLE_PARTNER')) && <OrganizationsPage/>}></Route>
              <Route path="applications-management" element={(roles.includes('ROLE_ADMIN') || roles.includes('ROLE_MANAGER') || roles.includes('ROLE_PARTNER') || roles.includes('ROLE_CURATOR')) && <ApplicationsManagementPage/>}></Route>
          </Route>
          <Route path="/auth" element={<AuthLayout />}>
              <Route path="login" element={<LoginPage/>}></Route>
              <Route path="register" element={<RegisterPage/>}></Route>
          </Route>
          <Route path="/public/order/:id" element={<PublicOrder/>}></Route>
          <Route path="/logout" element={<LogoutPage/>}></Route>
          <Route path="/direct" element={<DirectPage/>}></Route>
      </Routes>
      </ConfigProvider>
  );
}

export default App;
